module.exports = __webpack_public_path__ + "static/logo-0cd1d4035c8dde922f5ff7eefdd8e1ae.png";